import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react';

const DisableEscapeKeyDownContext = createContext();

export const DisableEscapeKeyDownProvider = ({ children }) => {
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);

  const enableEscapeKeyDown = useCallback(
    () => setDisableEscapeKeyDown(false),
    []
  );
  const disableEscapeKeyDownHandler = useCallback(
    () => setDisableEscapeKeyDown(true),
    []
  );

  const value = useMemo(
    () => ({
      disableEscapeKeyDown,
      enableEscapeKeyDown,
      disableEscapeKeyDownHandler,
    }),
    [disableEscapeKeyDown, enableEscapeKeyDown, disableEscapeKeyDownHandler]
  );

  return (
    <DisableEscapeKeyDownContext.Provider value={value}>
      {children}
    </DisableEscapeKeyDownContext.Provider>
  );
};

export const useDisableEscapeKeyDown = () => {
  const context = useContext(DisableEscapeKeyDownContext);
  if (!context) {
    throw new Error(
      'useDisableEscapeKeyDown must be used within a DisableEscapeKeyDownProvider'
    );
  }
  return context;
};
